/**
 * Fire an event
 *
 * @param eventName
 * @param data
 * @param options
 */
export const fireEvent = (eventName, data = {}, options = {}) => {
  let event

  if (Object.keys(data).length || Object.keys(options).length) {
    event = new CustomEvent(eventName, {
      detail: {
        ...data
      },
      ...options
    })
  } else {
    event = new Event(eventName)
  }

  window.dispatchEvent(event)
}

export const registerEventListener = (name, event, eventOptions = false) => {
  window.addEventListener(name, event, eventOptions)
}

export const unregisterEventListener = (name, event) => {
  window.removeEventListener(name, event)
}

/**
 * Capitalizes a string
 *
 * @param value
 */
export const capitalize = (value) => {
  if (typeof value !== 'string') { return value }

  return value.charAt(0).toUpperCase() + value.slice(1)
}

/**
 * Generates an event type
 *
 * @param name
 * @returns {{label: *, event: *}}
 */
export const generateEventType = (name) => {
  const words = name.split(' ')

  const label = words.map(word => capitalize(word)).join(' ')
  const event = words.map((word, index) => index === 0 ? word : capitalize(word)).join()

  return {
    label,
    event
  }
}
